
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { AppRoutes } from './app.routing';
import { AppComponent } from './app.component';

import { FlexLayoutModule } from '@angular/flex-layout';
import { FullComponent } from './layouts/full/full.component';
import { AppHeaderComponent } from './layouts/full/header/header.component';
import { AppSidebarComponent } from './layouts/full/sidebar/sidebar.component';
import { ConfigurationComponent } from './layouts/full/sidebar/configuration.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DemoMaterialModule } from './demo-material-module';

import { SharedModule } from './shared/shared.module';
import { SpinnerComponent } from './shared/spinner.component';

import { ConfigService } from './services/config.service';
import { AuthService } from './services/auth.service';

import {DialogModule} from 'primeng/dialog';
import { AuthInterceptor } from '../app/interceptor/auth.interceptor';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import {ClipboardModule} from '@angular/cdk/clipboard'; 

import {HashLocationStrategy} from '@angular/common';


import {MatInputModule} from '@angular/material/input';

@NgModule({
  declarations: [
    AppComponent,
    FullComponent,
    AppHeaderComponent,
    SpinnerComponent,
    AppSidebarComponent,
    ConfigurationComponent
  ],
  entryComponents: [
    ConfigurationComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    DemoMaterialModule,
    FormsModule,
    FlexLayoutModule,
    HttpClientModule,
    SharedModule,
    RouterModule.forRoot(AppRoutes, { enableTracing: false, useHash:true }),
    DialogModule,
    ClipboardModule,
    MatInputModule
   
  ],
  providers: [
    {
      provide: LocationStrategy,
      useClass: PathLocationStrategy
    },ConfigService,AuthService,
    {provide: LocationStrategy, useClass: HashLocationStrategy},
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
